import { injectReducer } from 'store/reducers'

export default (store) => ({
  path: 'practice-template/:id',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([
      './containers/PracticeTemplateUpdateContainer',
      './modules/PracticeTemplateUpdate'
    ], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const PracticeTemplateUpdate = require('./containers/PracticeTemplateUpdateContainer').default
      const actions = require('./modules/PracticeTemplateUpdate')
      const reducer = require('./modules/PracticeTemplateUpdate').default

      /*  Add the reducer to the store on key named below*/
      injectReducer(store, { key: 'practiceTemplateUpdate', reducer: reducer })

      store.dispatch(actions.initialize())
      store.dispatch(actions.fetchFeatures())
      store.dispatch(actions.fetchPracticeTemplate(nextState.params.id))
      /*  Return getComponent   */
      cb(null, PracticeTemplateUpdate)

      /* Webpack named bundle   */
    }, 'practiceTemplateUpdate')
  }
})



// WEBPACK FOOTER //
// ./src/routes/PracticeTemplateUpdate/index.js